module.exports = __webpack_public_path__ + "static/img/info_title2.e9eaca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/info_title2.png
// module id = Ld8P
// module chunks = 4